
import Vue from "vue";
import languages from "./../../constant/language"
import msDataProvider from "./../../services/msDataProvider";
import {StoreServiceInstance} from "@/services/storeService";

export default Vue.extend({
  data() {
    return {
      languages,
      overtime: false,
      binding: {
        setting: {
          language: 'en'
        }
      },
      itemsLanguage: [],
    };
  },
  methods: {
    async updateSetting() {
      await StoreServiceInstance.setData('language', this.binding.setting.language)
      this.$router.push("/");
    },
  },
  created() {
    this.itemsLanguage = this.languages
    msDataProvider.bindDataMany(["uiConfig"], this.binding, this, null, this);
  },
});
